import { Elements } from 'prismic-reactjs';
import { ArticleSliceType, RichTextContent } from '@contracts';

export interface FilterHeadersFromTextContent {
  id: string;
  slice_type: string;
  primary: {
    rich_text: {
      richText: RichTextContent[];
      text: string;
    };
  };
}

export const filterHeadersFromTextContent = (content: FilterHeadersFromTextContent[]): RichTextContent[] => {
  const articleItemsHeaders1: RichTextContent[] = [];
  const articleItemsHeaders2: RichTextContent[] = [];
  for (let i = 0; i < content.length; i += 1) {
    const item = content[i];
    const isRichText = item.slice_type === ArticleSliceType.RichText;
    if (isRichText) {
      const allTextsInIt = item.primary.rich_text.richText;
      const headers1 = allTextsInIt.filter((aText) => aText.type === Elements.heading1);
      articleItemsHeaders1.push(...headers1);
      const headers2 = allTextsInIt.filter((aText) => aText.type === Elements.heading2);
      articleItemsHeaders2.push(...headers2);
    }
  }
  return articleItemsHeaders1.length > 0 ? articleItemsHeaders1 : articleItemsHeaders2;
};

export interface HeaderItem {
  text: string;
  id: string;
}

export const createTitlesArray = (headers: RichTextContent[]): HeaderItem[] => {
  return headers.map((header) => ({
    text: header.text,
    id: header.text.toLowerCase().replace(/\s+/g, '-')
  }));
};
